import React from 'react';
import { useShipmentContext } from '../../../../components/ShipmentProvider/ShipmentProvider';
import AddressSection from '../../../../components/AddressSection';

const ShipmentAddressSection = () => {
  const { addresses, isFetchingAddress } = useShipmentContext();
  const { from: fromAddress, to: toAddress } = addresses || {};

  return (
    <AddressSection isLoading={isFetchingAddress} fromAddress={fromAddress} toAddress={toAddress} />
  );
};

export default ShipmentAddressSection;
